import { Controller } from '@hotwired/stimulus';
import { loadOrgKeyFromStorage, importPublicKey, hybridEncryptOrgKey } from '../vault_crypto';

export default class extends Controller {
  static targets = ['approveButton'];
  static values = {
    requestId: Number,
    requesterName: String,
    publicKeySnapshot: String,
    t: Object,
  };

  approve(event) {
    event.preventDefault();

    if (window.vault?.is_open()) {
      this.doApprove();
    } else {
      window.vault?.openModal(() => this.doApprove());
    }
  }

  async doApprove() {
    const btn = this.approveButtonTarget;
    btn.disabled = true;
    btn.textContent = this.tValue.approving;

    try {
      const orgPrivKey = await loadOrgKeyFromStorage();
      const orgPrivBytes = await crypto.subtle.exportKey('pkcs8', orgPrivKey);

      const requesterPub = await importPublicKey(this.publicKeySnapshotValue);
      const encOrgPrivateKey = `0:${await hybridEncryptOrgKey(orgPrivBytes, requesterPub)}`;

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = `/vault_key_requests/${this.requestIdValue}/approve`;

      const tokenMeta = document.querySelector('meta[name="csrf-token"]');
      if (tokenMeta) {
        const csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = 'authenticity_token';
        csrfInput.value = tokenMeta.content;
        form.appendChild(csrfInput);
      }

      const keyInput = document.createElement('input');
      keyInput.type = 'hidden';
      keyInput.name = 'vault_key_request[encrypted_org_private_key]';
      keyInput.value = encOrgPrivateKey;
      form.appendChild(keyInput);

      document.body.appendChild(form);
      form.submit();
    } catch (e) {
      console.error('Approve failed:', e);
      btn.disabled = false;
      btn.textContent = this.tValue.approve;
      alert(this.tValue.approve_failed);
    }
  }
}
